export default "__VITE_ASSET__64494f75__"